/* eslint-disable import/no-anonymous-default-export */
export default {
  stables: {
    list: [],
    current: null,
    loading: false,
    fetching: true,
  },
};
